module.exports = __webpack_public_path__ + "img/backgroud1.10ddf02e.jpeg";